export default __webpack_public_path__ + "static/media/collab2.4b481306.png";